/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProfileAliases {
  CARD_CONTENT = 'card-content',
  CONTEXTUAL_BAR_CARD = 'contextual-bar-card',
  DASHBOARD_CONTENT = 'dashboard-content',
  FETCH_PROFILE = 'fetch-profile',
  FIELD_USER_EMAIL = 'field-user-email',
  FIELD_USERNAME = 'field-username',
  FORM_PROFILE = 'form-profile',
  LAYOUT_1 = 'layout-1',
  LAYOUT_PROFILE = 'layout-profile',
  LINK_TERMS_LIST = 'link-terms-list',
  PANEL_CARD = 'panel-card',
  PANEL_FOOTER_PROFILE = 'panel-footer-profile',
  PANEL_LINK = 'panel-link',
  PANEL_PROFILE = 'panel-profile',
  PROFILE_USER_EMAIL_TEXT = 'profile-user-email-text',
  PROFILE_USERNAME_TEXT = 'profile-username-text',
  TEXT_LAST_ACESS = 'text-last-acess',
}
export { ProfileAliases };
